import { useSyncExternalStore } from 'react';
const MOBILE_QUERY = '(max-width: 767px)';
const mql = typeof window !== 'undefined' ? window.matchMedia(MOBILE_QUERY) : null;
function subscribe(callback) {
  mql === null || mql === void 0 || mql.addEventListener('change', callback);
  return () => mql === null || mql === void 0 ? void 0 : mql.removeEventListener('change', callback);
}
function getSnapshot() {
  var _mql$matches;
  return (_mql$matches = mql === null || mql === void 0 ? void 0 : mql.matches) !== null && _mql$matches !== void 0 ? _mql$matches : false;
}

/** Returns true when the viewport is below the md breakpoint (768px) */
export function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot, _temp);
}
function _temp() {
  return false;
}